import React from "react";
import { IconFromSet } from "../../icons";
import { IconPickerIconButtonProps } from "./IconPicker.types";

const classes = {
  IconName: "text-xs w-full pt-2 text-center break-words",
  IconButton:
    "flex w-full flex-col items-center max-w-[82px] rounded p-2 hover:bg-accent hover:cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
};

export const IconPickerIconButton: React.FC<IconPickerIconButtonProps> = ({
  icon,
  iconName,
  onClick,
  iconSet,
  iconUrl
}) => {
  return (
    <button type="button" className={classes.IconButton} onClick={onClick}>
      {iconUrl ? (
        // Decorative: the name is written under it
        <img src={iconUrl} alt="" className="h-8 w-8" />
      ) : (
        <IconFromSet icon={{ icon, set: iconSet }} />
      )}
      <div className={classes.IconName}>{iconName}</div>
    </button>
  );
};
